
<script>
    import {mapGetters, mapState} from 'vuex';
    export default {
        data(){
            return {
                sectionType: "topbar",
            }
        },
        computed: {
            ...mapState('topbar',[
                'activeTopbarStatus',
            ]),
            ...mapGetters('pages',[
                'pageProperties'
            ]),
            isActiveTopbar () {
                return this.pageProperties.has_top_bar && this.activeTopbarStatus === this.topbarStatus;
            }
        },
        methods: {
            sectionCreationStartCallback () {
                this.setTopbarStatus();
            },


        }
    }
</script>
